import { Tooltip } from '@mantine/core';
import { HelpCircle } from 'lucide-react';

interface FieldHelpTooltipProps {
  label: React.ReactNode;
}

// Small inline help affordance so business users get plain-language context without leaving the
// form — used next to any label whose terminology (bound, tier, contracted value...) isn't
// self-explanatory. Shared across features (Quality Formulas, Templates), not feature-specific.
export const FieldHelpTooltip: React.FC<FieldHelpTooltipProps> = ({ label }) => (
  <Tooltip label={label} multiline position="top-start" w={280} withArrow withinPortal>
    <HelpCircle
      aria-label="Field help"
      role="img"
      size={14}
      style={{ color: 'var(--mantine-color-dimmed)', cursor: 'help', flexShrink: 0 }}
    />
  </Tooltip>
);
